import { AdminMiniDescriptor } from './admin-mini.types';

/**
 * The two admin Mini tools.
 *
 * Kept beside the descriptor type rather than next to either tool, because the point of the pair is
 * that they can be read side by side: what differs between a mystery shop and a sniff is exactly
 * the lines that differ below, and nothing else.
 */

export const MYSTERY_SHOPPER: AdminMiniDescriptor = {
    systemCode: 'mystery_shopper',
    runNoun: 'mystery shop',
    title: 'Mystery Shopper',
    runResource: 'mystery_shoppers',
    resultResource: 'mystery_shopper_results',
    resultRunField: 'mysteryShopper.id',
    routes: {
        activate: 'hq/mystery-shopper/admin/activate',
        cancel: 'hq/mystery-shopper/admin/cancel',
        sendEmail: 'hq/mystery-shopper/admin/email/send',
    },
    acl: {
        open: 'HQ_Mini::mystery_shopper_open',
        run: 'HQ_Mini::mystery_shopper_run',
        cancel: 'HQ_Mini::mystery_shopper_cancel',
        send: 'HQ_Mini::mystery_shopper_send',
        draft: 'HQ_Mini::mystery_shopper_draft',
    },
    // One mode, so the form offers no choice. A mystery shop is a Nok persona approaching a
    // business; there is no version of it that arrives from Nok Nok's own compliance address.
    senderModes: ['nok'],
    supportsFormChannel: true,
};

export const COMPLIANCE_SNIFFER: AdminMiniDescriptor = {
    systemCode: 'compliance_sniffer',
    runNoun: 'sniff',
    title: 'Compliance Sniffer',
    runResource: 'compliance_sniffers',
    resultResource: 'compliance_sniffer_results',
    resultRunField: 'complianceSniffer.id',
    routes: {
        activate: 'hq/compliance-sniffer/admin/activate',
        cancel: 'hq/compliance-sniffer/admin/cancel',
        sendEmail: 'hq/compliance-sniffer/admin/email/send',
    },
    acl: {
        open: 'HQ_Mini::compliance_sniffer_open',
        run: 'HQ_Mini::compliance_sniffer_run',
        cancel: 'HQ_Mini::compliance_sniffer_cancel',
        send: 'HQ_Mini::compliance_sniffer_send',
        draft: 'HQ_Mini::compliance_sniffer_draft',
    },
    // The Nok pipe only (user, 2026-09-11). The session began with a decision that an admin would
    // choose per run, and the compliance pipe - sending from a typed address over the system
    // compliance domain, the way a customer's own sniff does - was built and tested on both sides.
    // The user then removed the option from the form, so an admin sniff introduces itself exactly
    // as an admin mystery shop does.
    //
    // `AdminSenderResolver` still understands `compliance` and is still covered, so this is one
    // word to put back. HQ-44 tracks taking the API half out if it is not wanted.
    senderModes: ['nok'],
    // A sniff has only ever had the email channel.
    supportsFormChannel: false,
};

/** Every tool with an admin half, by the `systemCode` its `NokMini` record carries. */
export const ADMIN_MINIS: Record<string, AdminMiniDescriptor> = {
    [MYSTERY_SHOPPER.systemCode]: MYSTERY_SHOPPER,
    [COMPLIANCE_SNIFFER.systemCode]: COMPLIANCE_SNIFFER,
};
